export default __webpack_public_path__ + "static/media/gnl4.af5fa140.webp";